import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import * as serviceWorker from "./serviceWorker";
import { store, persistor } from "helpers";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConnectedRouter } from "connected-react-router";
import { StripeProvider } from "react-stripe-elements";
import { history } from "helpers";

const STRIPE_API_KEY =
  process.env.NODE_ENV === "development"
    ? "pk_live_Celu8ZvlkpiVW74gLirSHK8g"
    : "pk_live_Celu8ZvlkpiVW74gLirSHK8g";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <StripeProvider apiKey={STRIPE_API_KEY}>
          <App />
        </StripeProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
